module.exports = __webpack_public_path__ + "static/media/sliders-vert.b00fd747.svg";